import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './Events.css';

const Events = () => {
  return (
    <div className="events">
      <motion.section
        className="events-coming-soon"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <motion.div
          className="coming-soon-content"
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <h1 className="coming-soon-title">Coming Soon</h1>
          <p className="coming-soon-subtitle">
            We're planning exciting events and exhibitions. Stay tuned for updates!
          </p>
          <Link to="/contact" className="coming-soon-button">
            Get Notified
          </Link>
        </motion.div>
      </motion.section>
    </div>
  );
};

export default Events;
